/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'course': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M473 846.7s-13.9 29.1-23.2 29.4l-342.4-.1c-15.3-.8-42.5-43.1-43.1-66.7V238h30.5v547.6c134.8 21.8 256.3 41.5 378.2 61.1zm60.5-33.6l-.1-479.7c-4.2-103.6 44.4-146 132.3-161.7 67.7-12.1 137-15.5 215.8-23.7 0 199.4-.3 566.6-.3 566.6l.3 47.3c-.1 0-178-13.8-348 51.2zm16.7 33.6c122-19.7 245.2-39.4 380-61.1V237.9h29l.1 571.3c-.7 23.6-26.4 65.9-41.7 66.7l-344.1.1c-9.3-.2-23.3-29.3-23.3-29.3zm-57.6-33.6l.1-479.7c4.2-103.6-44.5-146-132.3-161.7-67.7-12.1-136.9-15.5-215.8-23.8 0 199.4.3 566.6.3 566.6l-.3 47.3c.1.1 178.2-13.7 348 51.3"/>'
  }
})
